import { EnumVolunteerItemStatus } from './index';

export const defaultBoleInfo = {
  boleMis: '',
  boleName: '',
  staffSsoId: '',
  recommendationNum: '',
};

// 初始化投递状态
export const defaultApplyStatus = {
  isApplied: false,
  isOnline: false,
  canApply: false,
  applyJobStep: {
    code: '',
    name: '',
  },
  jobName: '',
};

// 初始化投递信息
export const defaultDeliveryInfo = {
  jobId: '',
  interestBG: {
    code: '',
    name: '',
  },
  workCityList: [{ code: '', name: '' }],
  acceptWorkCityAdjust: false,
  acceptJobAdjust: false,
  intentionJob: [
    {
      code: '',
      name: '',
      order: 1,
    },
  ],
  recommendationNum: '',
  source: '',
};

/**
 * @description: 志愿单item默认值
 */
export const defaultVolunteerItem = {
  volunteerStatus: 0,
  volunteerItemId: 0,
  jobId: '',
  jobName: '',
  isLikeAllBG: false,
  isLikeAllCity: false,
  // 不要加默认interestBG,不然表单校验会认为有值
  // interestBG: {
  //   code: '',
  //   name: '',
  // },
  volunteerItemStatus: EnumVolunteerItemStatus.notStart,
  aspirationDirectionList: [],
};
